import { Subject, BehaviorSubject, combineLatest } from "rxjs";
import StorageService from "./storage.service";
import { DEFAULT_ESTIMATE_DATA, Measurement } from "./constants";
import { BinaryString, EstimateData, InsertConfigData, InsertData, MessageDetail, ModalData, ModeType, NameValue, SnapObject } from "./types";
import Insert from "../partials/Insert";
import { deepClone } from "./util.functions";

export const message$ = new BehaviorSubject<MessageDetail>({ show: false, type: 'tip' });

export const width$ = new BehaviorSubject<number>(StorageService.get('width') || Measurement.DEFAULT_WIDTH);

export const height$ = new BehaviorSubject<number>(StorageService.get('height') || Measurement.MIN_HEIGHT);

export const depth$ = new BehaviorSubject<number>(StorageService.get('depth') || Measurement.DEFAULT_DEPTH);

export const trayColor$ = new BehaviorSubject<NameValue | undefined>(StorageService.get('trayColor'));

export const mobileToggle$ = new BehaviorSubject<BinaryString>(StorageService.get('mobileToggle') || '1');

export const complete$ = new BehaviorSubject<boolean>(false);

export const subtotal$ = new BehaviorSubject<number>(0); // 3600 whole number

export const boardMode$ = new BehaviorSubject<ModeType>('nuetral');

export const inserts$ = new BehaviorSubject<InsertData[]>(StorageService.get('inserts') || []);

export const activeInsert$ = new BehaviorSubject<Insert | null>(null);

export const snapObject$ = new BehaviorSubject<SnapObject>({ x: [], y: [] });

export const addInsert$ = new Subject<InsertConfigData>();

export const deleteInsert$ = new Subject<string>();

export const updateInsert$ = new Subject<InsertData>();

export const estimate$ = new BehaviorSubject<EstimateData>(deepClone(DEFAULT_ESTIMATE_DATA) as EstimateData);

export const trayData$ = combineLatest({
  width: width$,
  height: height$,
  depth: depth$,
  inserts: inserts$,
  subtotal: subtotal$,
  color: trayColor$,
});

export const modal$ = new Subject<ModalData>();
